// pages/+redux.ts
// Environment: client, server

import { createStore } from '../redux/createStore'
export default { createStore } 